import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
const modulos = [{
  num: '1',
  emoji: '📘',
  title: 'El Diagnóstico Maestro',
  desc: 'Tests caseros para identificar el origen exacto de tu humedad. Sin gastar un peso antes de saber qué tenés.'
}, {
  num: '2',
  emoji: '📗',
  title: 'La Barrera Química',
  desc: 'El protocolo completo de perforación e inyección. Ángulos exactos, profundidades calculadas, protocolo de carga.'
}, {
  num: '3',
  emoji: '📙',
  title: 'La Protección Exterior',
  desc: 'Membrana de techo, sellado de juntas, pendientes y pintura reflectante. El exterior cerrado para siempre.'
}, {
  num: '4',
  emoji: '📕',
  title: 'El Mantenimiento Inteligente',
  desc: 'Calendario anual, alertas tempranas y el Expediente Técnico que aumenta el valor de tu propiedad.'
}];
export function ModulosSection() {
  return <section className="py-8 md:py-10 px-4 bg-slate-950" data-id="element-167">
      <div className="max-w-3xl mx-auto" data-id="element-168">
        <div className="space-y-4 mb-6" data-id="element-169">
          {modulos.map((modulo, index) => <FadeIn key={modulo.num} delay={index * 0.1} data-id="element-170">
              <div className="bg-slate-900 border border-slate-800 border-l-4 border-l-orange-500 rounded-r-xl p-5 md:p-6 shadow-md" data-id="element-171">
                <h3 className="text-lg md:text-xl mb-2 leading-snug" data-id="element-172">
                  <span className="mr-2" data-id="element-173">{modulo.emoji}</span>
                  <span className="text-orange-500 font-bold" data-id="element-174">
                    MÓDULO {modulo.num} —{' '}
                  </span>
                  <span className="text-white font-bold" data-id="element-175">{modulo.title}</span>
                </h3>
                <p className="text-slate-400 leading-relaxed text-base md:text-lg" data-id="element-176">
                  {modulo.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-177">
          <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6" data-id="element-178">
            <h3 className="text-xl font-bold text-white mb-4 text-center" data-id="element-179">
              Cada módulo incluye:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-180">
              {['Tests e ilustraciones paso a paso', 'Protocolos con tiempos exactos', 'Checklists de verificación', 'Planillas imprimibles A4 para usar en obra', 'Tabla de materiales con marcas argentinas y precios estimados'].map((item, i) => <div key={i} className={`flex items-center gap-3 ${i === 4 ? 'md:col-span-2 md:justify-center' : ''}`} data-id="element-181">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-182" />
                  <span className="text-slate-300" data-id="element-183">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}